import { render } from "./CodeField.vue?vue&type=template&id=0bdc11c1&scoped=true&ts=true"
import script from "./CodeField.vue?vue&type=script&lang=ts"
export * from "./CodeField.vue?vue&type=script&lang=ts"

import "./CodeField.vue?vue&type=style&index=0&id=0bdc11c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdc11c1"]])

export default __exports__